import React from 'react';
import styles from './answers.module.scss';
import { getCarbonLabel } from '../../utils';

const CustomCo2Answer = (props) => {
  const { answer } = props;
  const { data } = answer;
  return (
    <div className={styles.answerContainer}>
      {data?.map((item, index) => (
        <div key={`${answer.id}${index + 1}`} className={styles.answerItem}>
          <div>
            <h4>Activity {index + 1}:</h4>
          </div>
          <div className={styles.answerDataContainer}>
            <div key={`${data}${index + 1}`} className={styles.answerTextItem}>
              <span className={styles.label}>{'Item: '}</span>
              {item.item.name}
            </div>
            <div key={`${data}${index + 1}`} className={styles.answerTextItem}>
              <span className={styles.label}>{'Quantity: '}</span>
              {item.quantity}
            </div>
            <div key={`${data}${index + 1}`} className={styles.answerTextItem}>
              <span className={styles.label}>{'Supplier: '}</span>
              {`${item.supplier.firstName} ${item.supplier.lastName}`}
            </div>
            <div key={`${data}${index + 1}`} className={styles.answerTextItem}>
              <span className={styles.label}>{'Footprint: '}</span>
              {item.footprint}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomCo2Answer;
